import React from "react";
import * as S from "./styles";
import { Monthler, MonthlerImage } from "./styles";
import Logo from "../../assets/logo.png";

const PageFooterBusiness = ({ partnerName }: { partnerName: string }) => {
  const handleClick = () => {
    window.open("https://www.monthler.kr", "_blank");
  };

  return (
    <S.Container>
      {partnerName && <S.PartnerName>이 프로그램은 {partnerName}에서 진행합니다.</S.PartnerName>}
      <S.MonthlerWrapper>
        <S.MonthlerImage src={Logo} alt="한달살러 신청서" />
        <S.Monthler onClick={handleClick}>한달살러 신청서</S.Monthler>
      </S.MonthlerWrapper>
      <S.BusinessText>
        회사명 : 노마드씨 | 사업자등록번호 : 274-61-00179 | 대표 : 조희정 | 통신판매업 신고번호 :
        2023-광주광산-0919
        <br />
        유선: 070-8080-0935 | 광주광역시 광산구 임방울대로 154-29, 1층 101-227호 | 문의 :
        nomadc.monthler@gmail.com
      </S.BusinessText>
    </S.Container>
  );
};

export default PageFooterBusiness;
